<template>
  <Transition name="splash-fade">
    <div v-if="loading" class="splash-screen">
      <div class="splash-inner">
        <div class="spinner-ring">
          <div class="ring r1" />
          <div class="ring r2" />
          <div class="ring r3" />
          <div class="nxdot" />
        </div>
        <div class="splash-brand"><span class="brand-nx">NX</span><span class="brand-con">con</span></div>
        <p class="splash-sub">Initializing secure session…</p>
      </div>
    </div>
  </Transition>
  <RouterView />
  <CheckoutOverlay />
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import CheckoutOverlay from './pages/services/Checkout.vue'

const loading = ref(true)

onMounted(() => {
  setTimeout(() => {
    loading.value = false
  }, 1200)
})
</script>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}

/* ── Splash Screen ──────────────────────────────────────────── */
.splash-screen {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(ellipse at 50% 40%, #0c1510 0%, #060b08 70%);
  flex-direction: column;
}

.splash-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}

/* ── Three concentric spinning rings ── */
.spinner-ring {
  position: relative;
  width: 96px;
  height: 96px;
}

.ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 3px solid transparent;
  animation: spin linear infinite;
}

.r1 {
  border-top-color: #22c55e;
  animation-duration: 1s;
}
.r2 {
  inset: 10px;
  border-top-color: #10b981;
  border-right-color: #10b98133;
  animation-duration: 1.4s;
  animation-direction: reverse;
}
.r3 {
  inset: 22px;
  border-top-color: #06b6d4;
  animation-duration: 1.8s;
}

/* ── Centre dot ── */
.nxdot {
  position: absolute;
  inset: 38px;
  border-radius: 50%;
  background: #22c55e;
  animation: pulse 1.4s ease-in-out infinite;
  box-shadow: 0 0 18px #22c55e99;
}

/* ── Brand text ── */
.splash-brand {
  font-size: 2rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1;
}

.brand-nx {
  color: #22c55e;
}

.brand-con {
  color: #e2e8f0;
}

.splash-sub {
  font-size: 0.78rem;
  color: #4ade8055;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin: 0;
  animation: blink 1.4s ease-in-out infinite;
}

/* ── Transition ── */
.splash-fade-leave-active {
  transition:
    opacity 0.5s ease,
    transform 0.5s ease;
}
.splash-fade-leave-to {
  opacity: 0;
  transform: scale(1.04);
}

/* ── Keyframes ── */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(0.7);
    opacity: 0.5;
  }
}

@keyframes blink {
  0%,
  100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}
</style>
